import { cva, type VariantProps } from "class-variance-authority";

export const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-1 text-caption font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "border-primary text-primary",
        success: "border-transparent bg-success text-success-foreground",
        warning: "border-transparent bg-warning text-warning-foreground",
        connect: "border-transparent bg-primary text-primary-foreground",
        clarity: "border-transparent bg-warning text-warning-foreground",
        courage: "border-transparent bg-success text-success-foreground",
        own: "border-transparent bg-warning text-warning-foreground",
        respond: "border-transparent bg-success text-success-foreground",
        elevate: "border-transparent bg-accent text-accent-foreground",
        active: "border-transparent bg-primary/15 text-primary",
        consolidation: "border-transparent bg-success/15 text-success",
        graduated: "border-transparent bg-success text-success-foreground",
        paused: "border-transparent bg-muted text-muted-foreground",
        urgency: "border-transparent bg-destructive text-destructive-foreground animate-pulse",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export type BadgeVariantProps = VariantProps<typeof badgeVariants>;
